import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanDeferralMode extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanDeferralMode';
}
